// A bird in the flock row: portrait, name, one status word. Tapping it opens
// that bird's screen (U5).

import { t } from '../../i18n';
import { button, h } from '../dom';
import type { BirdChipView } from '../selectors';

export interface BirdChipOptions {
  view: BirdChipView;
  onOpen: (chickenId: string) => void;
}

export function birdChip(options: BirdChipOptions): HTMLButtonElement {
  const { view } = options;
  const label = `${view.name} — ${t(view.statusKey)}`;
  return button(
    {
      class: `cf-birdchip cf-birdchip--${view.tone}`,
      attrs: { 'aria-label': label },
      on: { click: () => options.onOpen(view.id) },
    },
    h('img', { class: 'cf-birdchip__img', attrs: { src: view.sprite, alt: '' } }),
    h(
      'span',
      { class: 'cf-stack cf-stack--tight cf-grow' },
      h('span', { class: 'cf-birdchip__name', text: view.name }),
      h('span', { class: 'cf-birdchip__status', text: t(view.statusKey) }),
    ),
  );
}
